<template>
  <div class="layout">
    <!-- topbar -->
    <Topbar :user-info="userInfo" />
    <div class="layout-container">
      <!-- main nav -->
      <MainNav />
      <!-- router view -->
      <router-view />
    </div>
    <!-- 用户信息获取后再初始化 -->
    <ImWeb v-if="userInfo.id" />
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import storeUser from '@/store/modules/user.js';
import storePermission from '@/store/modules/permission.js';
import storeUi, { UPDATE_SOCKET_CONNECT_STATUS } from '@/store/modules/ui.js';
import Socket from '@/utils/socket';

import Topbar from './topbar';
import MainNav from './main-nav';
import ImWeb from '@/components/im-web';

export default {
  name: 'Layout',
  components: {
    Topbar,
    MainNav,
    ImWeb,
  },
  data() {
    return {
      isCollapse: false,
    };
  },
  computed: {
    ...mapGetters(storeUser.name, ['userInfo']),
    ...mapGetters(storeUi.name, ['isSocketConnected']),
    ...mapGetters(storePermission.name, ['menus']),
  },
  watch: {
    // 获取到用户信息后触发
    'userInfo.id': async function (userId) {
      console.log('用户userId: ', userId);
      if (userId) {
        // socket实例化并挂载到全局
        window.ZP.socket = new Socket(userId, 1);
        // 更新socket连接状态, 后续使用
        this.updateSocketConnectStatus(1);
      }
    },
    // 用户是否有当前页面访问权限
    menus(value) {
      const route = this.$route.meta.route;
      const mainMenu = this.menus.find(({ path }) => path === route.path);
      if (route.path === '/index') {
        return;
      }
      // 无权限访问页面: 1.动态更新用户权限后刷新页面
      if (!mainMenu) {
        console.log('主菜单不存在去首页');
        this.$router.push({ path: '/' });
        // return;
      }
      // // todo: 三级页面刷新会回到首页
      // 可通过页面配置文件添加二级页面路由处理
      // if (!mainMenu.children.some(({ path }) => path === route.children.path)) {
      //   console.log('子菜单不存在去首页');
      //   this.$router.push({ path: '/' });
      // }
    },
    // socket connected status
    isSocketConnected(status) {
      console.log('socket连接状态改变：', status);
      // 已连接时添加消息监听事件
      if (status === 1) {
        ZP.socket.on('receive_message', (msg) => {
          console.log('layout socket 接受全局消息：', msg);
        });
      }
    },
  },
  created() {
    // 获取并初始化用户信息
    this.fetchUser();
    // 获取并初始化用户权限
    this.fetchPermission();
  },
  beforeDestroy() {
    // 手动关闭socket连接
    ZP.socket && ZP.socket.close();
  },
  methods: {
    ...mapMutations(storeUi.name, {
      updateSocketConnectStatus: UPDATE_SOCKET_CONNECT_STATUS,
    }),
    ...mapActions(storeUser.name, ['fetchUser']),
    ...mapActions(storePermission.name, ['fetchPermission']),
  },
};
</script>
